<template>
  <li v-show="currentVisibled"
      :class="listItemClasses"
      @click.stop="fireClick"
  >
    <a ref="valueTag"><slot>{{ currentLabel }}</slot></a>
  </li>
</template>
<script>
import { PREFIX_CLASS } from '../../utils/constants'
import bus from '../../utils/bus'
import {
  BUS_LIST_ITEM__ASK,
  BUS_LIST__VALUE_CHANGE,
  BUS_LIST_ITEM__VISIBLE,
  BUS_LIST_ITEM__INVISIBLE,
  BUS_LIST__REGISTER,
  BUS_LIST__UNREGISTER
} from './constants'
const PREFIX_LIST_CLASS = `${PREFIX_CLASS}list__item`

export default {
  name: 'TListItem',
  inject: {
    owner: 'owner',
    ownerGroup: {
      from: 'ownerGroup',
      default: null
    }
  },
  props: {
    value: {
      type: [String, Number, Boolean, Object, Array, Date, Function, Symbol],
      default: null,
      required: true
    },
    label: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    visibled: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      currentLabel: null,
      currentVisibled: true,
      // checked: false,
      focused: false,
      listValue: {}
    }
  },
  computed: {
    checked() {
      if (Array.isArray(this.listValue)) {
        if (this.listValue.length === 0) return false
        return !!(this.listValue.find(({ label, value }) => {
          return value != null && value === this.value
        }))
      }
      const { value } = this.listValue
      return value != null && value === this.value
    },
    finalLabel() {
      return this.currentLabel
    },
    listItemClasses() {
      return [
        PREFIX_LIST_CLASS,
        {
          [`${PREFIX_LIST_CLASS}--disabled`]: this.disabled,
          [`${PREFIX_LIST_CLASS}--checked`]: this.checked && !this.owner.multiple,
          [`${PREFIX_LIST_CLASS}--checked-multiple`]: this.checked && this.owner.multiple,
          [`${PREFIX_LIST_CLASS}--focus`]: this.focused
        }
      ]
    }
  },
  watch: {
    label(val) {
      if (val !== '') {
        this.currentLabel = val
      }
    },
    visibled(val) {
      this.currentVisibled = val
      if (this.ownerGroup !== null) {
        bus.$emit(val ? BUS_LIST_ITEM__VISIBLE : BUS_LIST_ITEM__INVISIBLE, this.ownerGroup)
      }
    }
    // checked(val) {
    //   bus.$emit(BUS_LIST_ITEM__ASK, this.owner, this, val)
    // }
  },
  created() {
    bus.$on(BUS_LIST__VALUE_CHANGE, this.$_onBusListValueChange)
    this.currentVisibled = this.visibled
  },
  beforeDestroy() {
    bus.$emit(BUS_LIST__UNREGISTER, this.owner, this)
  },
  mounted() {
    bus.$emit(BUS_LIST__REGISTER, this.owner, this)
    if (this.label !== '') {
      this.currentLabel = this.label
    } else {
      this.currentLabel = this.$refs.valueTag.innerText
    }
  },
  methods: {
    $_onBusListValueChange(owner, value) {
      if (this.owner === owner && value != null) {
        this.listValue = value
        // if (Array.isArray(value) === true) {
        //   if (value.length === 0) {
        //     this.uncheck(true)
        //   } else {
        //     let checked = false
        //     for (let i = value.length - 1; i >= 0; i--) {
        //       if (value[i].label === this.currentLabel &&
        //           value[i].value === this.value) {
        //         this.check(true)
        //         checked = true
        //         break
        //       }
        //     }
        //     if (checked === false) {
        //       this.uncheck(true)
        //     }
        //   }
        // } else {
        //   if (this.value === value) {
        //     this.check(true)
        //   } else {
        //     this.uncheck(true)
        //   }
        // }
      }
    },
    fireClick() {
      if (this.disabled) return
      // bus.$emit('clearCascader', this.$parent.$parent.$parent, this.checked) // 选择某个级联之后会清楚掉下个级联
      bus.$emit(BUS_LIST_ITEM__ASK, this.owner, this, !this.checked)
    },
    // check(forced = false) {
    //   if (this.checked === false) {
    //     if (forced) {
    //       this.checked = true
    //     } else {
    //       bus.$emit(BUS_LIST_ITEM__ASK, this.owner, this, true)
    //     }
    //   }
    // },
    // uncheck(forced = false) {
    //   if (this.checked) {
    //     if (forced) {
    //       this.checked = false
    //     } else {
    //       bus.$emit(BUS_LIST_ITEM__ASK, this.owner, this, false)
    //     }
    //   }
    // },
    hide() {
      this.currentVisibled = false
    },
    show() {
      this.currentVisibled = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/module/list/list-item.vue